import "$styles/index.css"

console.info("byel.dev")
